import React from 'react';
import * as FiIcons from 'react-icons/fi';

// SafeIcon Component - Phase 14 Fixed
// Handles both string icon names and React icon components
// Falls back to calm neutral icons, never warning triangles
const SafeIcon = ({ icon, name, className = "text-lg", ...props }) => {
  let IconComponent = null;

  try {
    // If icon is already a React component, use it directly
    if (icon && typeof icon !== 'string' && icon.$$typeof) {
      IconComponent = icon;
    } 
    // If icon or name is a string, resolve from FiIcons
    else if (icon || name) {
      const iconName = typeof icon === 'string' ? icon : name;
      // Ensure proper Fi naming convention
      const formattedName = iconName.startsWith('Fi') ? iconName : `Fi${iconName}`;
      IconComponent = FiIcons[formattedName];
    }

    // Fallback to neutral circle icon (calm, not alarming)
    if (!IconComponent) {
      IconComponent = FiIcons.FiCircle;
    }

    return React.createElement(IconComponent, { className, ...props });
  } catch (error) {
    // Ultimate fallback - always render something calm
    return React.createElement(FiIcons.FiCircle, { className, ...props });
  }
};

export default SafeIcon;